var map = {
	"./banknotes/colorful.svg": 50795,
	"./banknotes/monochrome.svg": 67510,
	"./beer/colorful.svg": 49672,
	"./beer/monochrome.svg": 87537,
	"./beer_mug/colorful.svg": 68140,
	"./beer_mug/monochrome.svg": 29885,
	"./biceps/colorful.svg": 7766,
	"./biceps/monochrome.svg": 24707,
	"./bicycle/colorful.svg": 50485,
	"./bicycle/monochrome.svg": 22780,
	"./book/colorful.svg": 27811,
	"./book/monochrome.svg": 10718,
	"./bookshelf/colorful.svg": 19747,
	"./bookshelf/monochrome.svg": 47614,
	"./bubble_tea/colorful.svg": 87185,
	"./bubble_tea/monochrome.svg": 90208,
	"./cake/colorful.svg": 97786,
	"./cake/monochrome.svg": 40303,
	"./car/colorful.svg": 66390,
	"./car/monochrome.svg": 48131,
	"./coffee/colorful.svg": 37202,
	"./coffee/monochrome.svg": 78071,
	"./coins/colorful.svg": 8098,
	"./coins/monochrome.svg": 88679,
	"./computer/colorful.svg": 6679,
	"./computer/monochrome.svg": 89338,
	"./cookie/colorful.svg": 32072,
	"./cookie/monochrome.svg": 74961,
	"./cup/colorful.svg": 84576,
	"./cup/monochrome.svg": 70521,
	"./cupcake/colorful.svg": 22268,
	"./cupcake/monochrome.svg": 92173,
	"./dice/colorful.svg": 38845,
	"./dice/monochrome.svg": 64244,
	"./donut/colorful.svg": 99396,
	"./donut/monochrome.svg": 9125,
	"./dumbbells/colorful.svg": 81922,
	"./dumbbells/monochrome.svg": 30951,
	"./flowers/colorful.svg": 120,
	"./flowers/monochrome.svg": 74145,
	"./fortune_cookie/colorful.svg": 48674,
	"./fortune_cookie/monochrome.svg": 52327,
	"./gamepad/colorful.svg": 3667,
	"./gamepad/monochrome.svg": 40782,
	"./gift/colorful.svg": 41832,
	"./gift/monochrome.svg": 55057,
	"./heart/colorful.svg": 91692,
	"./heart/monochrome.svg": 23389,
	"./iced_latte/colorful.svg": 73174,
	"./iced_latte/monochrome.svg": 63299,
	"./kebab/colorful.svg": 62309,
	"./kebab/monochrome.svg": 96492,
	"./latte/colorful.svg": 84366,
	"./latte/monochrome.svg": 62091,
	"./microphone/colorful.svg": 398,
	"./microphone/monochrome.svg": 72587,
	"./pawns/colorful.svg": 80619,
	"./pawns/monochrome.svg": 33590,
	"./phone/colorful.svg": 14676,
	"./phone/monochrome.svg": 48469,
	"./pizza/colorful.svg": 77850,
	"./pizza/monochrome.svg": 3183,
	"./plane/colorful.svg": 12534,
	"./plane/monochrome.svg": 99107,
	"./plane_tickets/colorful.svg": 16212,
	"./plane_tickets/monochrome.svg": 90485,
	"./plant/colorful.svg": 86421,
	"./plant/monochrome.svg": 12348,
	"./server/colorful.svg": 52245,
	"./server/monochrome.svg": 53948,
	"./shopping_bags/colorful.svg": 47446,
	"./shopping_bags/monochrome.svg": 3587,
	"./sweets/colorful.svg": 25595,
	"./sweets/monochrome.svg": 37190,
	"./tea/colorful.svg": 2166,
	"./tea/monochrome.svg": 32035,
	"./tree/colorful.svg": 8130,
	"./tree/monochrome.svg": 27975,
	"./wallet/colorful.svg": 74947,
	"./wallet/monochrome.svg": 56638,
	"./watch_fitness/colorful.svg": 50088,
	"./watch_fitness/monochrome.svg": 68881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28187;